import { Box, Skeleton } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import HiddenMobile from '../../styles/HiddenMobile'

function CardsSkeleton() {
  return (
    <Box
      sx={{
        boxShadow: '4px 6px 20px rgb(0 0 0 / 10%)',
        position: 'relative',
        borderRadius: 1,
        backgroundColor: 'common.white'
      }}
    >
      <Grid
        container
        sx={theme => ({
          root: {
            [theme.breakpoints.up('lg')]: {
              display: 'inherit'
            },
            display: 'flex'
          }
        })}
      >
        <Grid xs={4} md={12}>
          <Skeleton
            sx={theme => ({
              [theme.breakpoints.up('sm')]: {
                height: '190px'
              },
              [theme.breakpoints.down('sm')]: {
                height: '100px'
              },
              borderRadius: '8px 8px 8px 0px'
            })}
            animation="wave"
            variant="rectangular"
            height="135px"
            width="100%"
          />
        </Grid>
        <Grid xs={8} md={12} style={{ padding: 8, paddingTop: 0 }}>
          <Box
            sx={theme => ({
              padding: 12,
              paddingBottom: 0,
              display: 'flex',
              flexDirection: 'column',
              [theme.breakpoints.down('sm')]: {
                padding: 8
              }
            })}
          >
            <Skeleton animation="wave" width="100%" height={26} variant="text" />
            <Skeleton animation="wave" width="100%" height={26} variant="text" />
            <HiddenMobile>
              <Skeleton animation="wave" width={120} height={16} variant="text" />
            </HiddenMobile>
          </Box>
          <Box style={{ padding: 0, justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
            <Box display="flex">
              <Skeleton animation="wave" variant="circular" height={30} width={30} style={{ margin: 12 }} />
              <Skeleton animation="wave" variant="circular" height={30} width={30} style={{ margin: 12 }} />
            </Box>
            <HiddenMobile>
              <Box display="flex" flexDirection="column" pr={2}>
                <Box>
                  <Skeleton animation="wave" width={110} height={24} variant="text" />
                </Box>
                <Box display="flex" alignItems="center" gap="2px">
                  <Skeleton animation="wave" width={80} height={24} variant="text" />
                </Box>
              </Box>
            </HiddenMobile>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default CardsSkeleton
